#import "./MediaFull.graphql"
#import "./AttachmentFull.graphql"
#import "./MetadataFull.graphql"
#import "./TimestampsFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./ComparisonParamFull.graphql"
#import "./ComparisonItemFull.graphql"
#import "./ContentBlockFull.graphql"

fragment NewsFull on News {
  id
  kind
  attachments {
    ...AttachmentFull
  }
  companyId
  comparisonItems {
    ...ComparisonItemFull
  }
  comparisonParams {
    ...ComparisonParamFull
  }
  content {
    ...ContentBlockFull
  }
  images {
    ...MediaFull
  }
  industries
  locale
  perex
  title
  urlSlug
  primaryImage {
    ...MediaFull
  }
  publishedAt
  tagIds
  ...MetadataFull
  ...TimestampsFull
  ...SearchIndexFull
}
